import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled, { CSSProperties } from "styled-components";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/components/navigation/navigation.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { SharedButton } from "@components";
import { IFreePoint } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { formatDateStartEnd } from "src/Utils/dateUtil";
import { Points } from "../shared/Point";

interface IProps {
    freePoint: IFreePoint;
    style?: CSSProperties;
    handleToggleConfirm: () => void;
    handleChangeImage: (swiper: SwiperCore) => void;
    currentImage: number;
    isConfirm?: boolean;
}

SwiperCore.use([Navigation, Pagination]);

export const ComponentFreePointDetail = (props: IProps) => {
    //page props
    const { freePoint, style, handleToggleConfirm, currentImage, handleChangeImage } = props;
    //page Hooks
    const { t } = useTranslation();
    const { themes } = useSelector(selectMerchant);
    const { showConfirm } = useSelector(selectAuth);

    const { isConfirm = true } = props;

    return (
        <StyledFreepointPage isConfirm={isConfirm} themeColor={themes?.themeColor!}>
            <div className="content-layout-fullpage">
                <div className="topic-page">{t("page.free_point")}</div>
                <div className="content-fullpage">
                    <div className="header-product">
                        <div className="layout-img">
                            <div className="img-product">
                                <img src={freePoint.imageUrl[0]} />
                            </div>
                        </div>
                        <div className="topic-product">{freePoint?.name || t("page.name")}</div>
                        <div className="point-product">
                            <span>
                                <Points size={20} />
                            </span>
                            {freePoint?.point} Points
                        </div>
                        <div className="expier-product">
                            EXP : {formatDateStartEnd(freePoint.startDate, freePoint.endDate)}
                        </div>
                    </div>
                    <div className="interception">
                        <div className="cutter left"></div>
                        <div className="middle-cutter"></div>
                        <div className="cutter right"></div>
                    </div>
                    <div className="content-product">
                        <div className="btn-main">
                            <StyledUsedBtn
                                className="btn-redeem"
                                themeColor={themes?.themeColor!}
                                type="submit"
                                onClick={handleToggleConfirm}
                            >
                                {t("page.collect_free_points")}
                            </StyledUsedBtn>
                        </div>
                    </div>
                </div>
            </div>
        </StyledFreepointPage>
    );
};

const StyledFreepointPage = styled.div<{ isConfirm: boolean; themeColor: string }>`
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        // background-color: #f2e8d7;
        background-image: url(../../images/bg-coupon.svg);

        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: #336c51;
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .control-text {
                max-height: 150px;
                overflow: scroll;
                width: 100%;
                word-break: break-all;
            }
            ul {
                li {
                    font-size: 12px;
                    line-height: 16px;
                    color: #9b9b9b;
                }
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #e9e9e9;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledButton = styled(SharedButton)`
    margin-top: 16px;
    /* height: 48px; */
`;
